import { createGlobalStyle } from 'styled-components/macro'
import { mq } from './mq'
import { theme } from './theme'
import { typography } from './typography'

export const GlobalStyle = createGlobalStyle`
:root {
  // Sizes
  --container-width: 155rem;
  --header-height: 5rem;

  --spacing-xsm: 1.5rem;
  --spacing-sm: 1.8rem;
  --spacing-md: 3rem;
  --spacing-lg: 5rem;
  --spacing-xlg: 7rem;

  --datawrapper-font: 1.6rem;

  --border-radius: 2.8rem;
  // Colors
  --background: ${theme.colors.background};
  --text-color: ${theme.colors.text};
  --primary-color: ${theme.colors.theme};

  // Swiper
  --swiper-theme-color: var(--text-color) !important;
  --swiper-pagination-bullet-inactive-opacity: 1;
  --swiper-pagination-bullet-inactive-color: white;
  --swiper-pagination-bullet-width: .6rem;
  --swiper-pagination-bullet-height: 1.2rem;
  --swiper-pagination-bullet-border-radius: .4rem;
  --swiper-pagination-right: 1.2rem;

} 

${mq.medium} {
  :root {
    --container-spacing: 4rem;
    --header-height: 7.4rem;

    --spacing-xsm: 1.8rem;
    --spacing-sm: 3rem;
    --spacing-md: 7rem;
    --spacing-lg: 8rem;
    --spacing-xlg: 12rem;

    --datawrapper-font: 1.4rem;
  }
}

html {
  height: 100%;
  font-size: 62.5%;
  overflow-x: hidden;
  scroll-behavior: smooth;
}

body {
  margin: 0;
  min-height: 100%;
  width: 100%;
  font-smooth: auto;
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
  -webkit-tap-highlight-color: transparent;
  color: var(--text-color);
  background: var(--background);
  color: ${theme.colors.text};
  ${typography.body};
}

*, *::before, *::after {
  box-sizing: border-box;
}

body.locked {
  overflow: hidden;
}

#root {
  display: contents;

  > * {
    flex-shrink: 0;
  }
}

a {
  color: inherit;
}
`
